import React from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";
import { ReactLenis } from 'lenis/react'
import Homepage from '../HomePage/HomePage'

import AboutPage from '../AboutPage/AboutPage';
import ServicePages from '../ServicePage/ServicePage';
import ServiceSinglePage from '../ServiceSinglePage/ServiceSinglePage';
import TeamPages from '../TeamPage/TeamPage';
import ProjectPage from '../ProjectPage/ProjectPage';
import BlogPageLeft from '../BlogPageLeft/BlogPageLeft'
import BlogDetails from '../BlogDetails/BlogDetails'
import ContactPage from '../ContactPage/ContactPage';
import ErrorPage from '../ErrorPage/ErrorPage';
import ProjectsByStatus from '../projectstatus/ProjectsByStatus';
import PrivacyPage from '../faqpage/faqpage';
import Career from '../career/Career';
import CareerDetail from '../career/CareerDetail';


const AllRoute = () => {


  return (
    <ReactLenis root>
      <div className="App" id="scroll">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="home" element={<Homepage />} />
            <Route path="aboutus" element={<AboutPage />} />
            <Route path="our-services" element={<ServicePages />} />
            <Route path="our-services/:slug" element={<ServiceSinglePage />} />
            <Route path="our-team" element={<TeamPages />} />
            <Route path="our-projects" element={<ProjectPage />} />
            {/* <Route path="/our-projects/:status" element={<ProjectsByStatus />} /> */}
            <Route path='our-blogs' element={<BlogPageLeft />} />
            <Route path='our-blogs/:slug' element={<BlogDetails />} />
            <Route path='404' element={<ErrorPage />} />
            <Route path='contact-us' element={<ContactPage />} />
            <Route path='FAQ' element={<PrivacyPage />} />
            <Route path='/career' element={<Career />} />
            <Route path="/career/:id" element={<CareerDetail />} />

          </Routes>
        </BrowserRouter>

      </div>

    </ReactLenis>
  );
}

export default AllRoute;
